module.exports = __webpack_public_path__ + "img/cover-1.8775bf5d.png";